import React from 'react';
import ModalDialog from '../../../core/components/Modal';
import InventoryTypeForm from '../components/InventoryTypeForm';
import { formValueSelector, getFormSyncErrors, reduxForm } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import { checkErrors } from '../../../core/formValidation';
import { addInventoryType } from '../actions';

const AddInventoryTypeDialog = (props) => {
  const dispatch = useDispatch();
  const onReady = () => {
    if (props.fields && props.fields.length > 0) {
      dispatch(addInventoryType(props.fields));
    }
  };

  const onSubmit = (values) => {
    props.onSubmit(values.types);
  };
  const submitDisabled = checkErrors(props.errors);

  return (
    <ModalDialog
      title="Add Inventory Type"
      onReady={onReady}
      isOpen={props.isOpen}
      close={props.hideDialog}
      disabled={submitDisabled}
      className="enhanced-dialog narrow padded-minimal"
    >
      <InventoryTypeForm onSubmit={onSubmit} {...props} />
    </ModalDialog>
  );
};

const AddInventoryTypeFormWrapper = (props) => {
  return <AddInventoryTypeDialog {...props} />;
};

const selector = formValueSelector('inventoryType');
const mapStateToProps = (state) => {
  const errors = getFormSyncErrors('inventoryType')(state);
  return {
    fields: selector(state, 'types'),
    errors,
  };
};

export default reduxForm({ form: 'inventoryType' })(
  connect(mapStateToProps)(AddInventoryTypeFormWrapper)
);
